import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=70a7327d&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=js"
export * from "./TheSidebar.vue?vue&type=script&lang=js"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&id=70a7327d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a7327d",
  null
  
)

export default component.exports